import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export type LinkRow = { label: string; url: string };

/**
 * Website, socials, press: a label and a URL, as many as somebody has.
 *
 * Shared by the profile page and the registration form's profile step, which
 * are the same fields written to the same columns. Two implementations of one
 * editor is how the two come to ask for different things.
 */
export function LinksEditor({
  value,
  onChange,
}: {
  value: LinkRow[];
  onChange: (next: LinkRow[]) => void;
}) {
  return (
    <div className="space-y-3">
      {value.map((link, i) => (
        <div key={i} className="flex gap-2">
          <Input
            aria-label="Link label"
            placeholder="Label"
            className="flex-1"
            value={link.label}
            onChange={(e) =>
              onChange(value.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))
            }
          />
          <Input
            aria-label="Link address"
            placeholder="https://…"
            className="flex-[2]"
            value={link.url}
            onChange={(e) =>
              onChange(value.map((x, j) => (j === i ? { ...x, url: e.target.value } : x)))
            }
          />
          <Button
            variant="ghost"
            size="icon"
            aria-label="Remove link"
            onClick={() => onChange(value.filter((_, j) => j !== i))}
          >
            <Trash2 />
          </Button>
        </div>
      ))}
      <Button
        variant="outline"
        size="sm"
        onClick={() => onChange([...value, { label: "", url: "" }])}
      >
        <Plus data-slot="icon" /> Add link
      </Button>
    </div>
  );
}

export default LinksEditor;
